var regionConfig = process.env.__REGION_CONFIG__;

export default regionConfig;
